var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"header-nav-select",staticStyle:{"max-width":"280px"},attrs:{"items":_vm.thematicList,"outlined":"","prepend-inner-icon":"mdi-label-variant","dense":"","hide-details":""},on:{"change":_vm.selectValue},model:{value:(_vm.selectedThematic),callback:function ($$v) {_vm.selectedThematic=$$v},expression:"selectedThematic"}})
}
var staticRenderFns = []

export { render, staticRenderFns }